import { API_ENDPOINTS, BASE_URL } from "../../constants/apiEndpoints";
import fetcher from "../../helpers/fetcher";

export const createNewsletter = (newsletterData: any): Promise<any> => {
  return fetcher.post(API_ENDPOINTS.NEWSLETTER.POST_SAVE_NEWSLETTER, newsletterData, {}, BASE_URL.CONSUMER_PRICE_BASE);
};

export const publishNewsletter = (id: number): Promise<any> => {
  return fetcher.post(
    `${API_ENDPOINTS.NEWSLETTER.NEWSLETTER}/${id}/publish`,
    {},
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );
};

export const unpublishNewsletter = (id: number): Promise<any> => {
  return fetcher.post(
    `${API_ENDPOINTS.NEWSLETTER.NEWSLETTER}/${id}/unpublish`,
    {},
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );
};

export const deleteNewsletter = (id: number): Promise<any> => {
  return fetcher.post(
    `${API_ENDPOINTS.NEWSLETTER.NEWSLETTER}/${id}/delete`,
    {},
    {},
    BASE_URL.CONSUMER_PRICE_BASE
  );
}; 
